import { render, staticRenderFns } from "./NewPoints.vue?vue&type=template&id=25a06c27&scoped=true"
import script from "./NewPoints.vue?vue&type=script&lang=js"
export * from "./NewPoints.vue?vue&type=script&lang=js"
import style0 from "./NewPoints.vue?vue&type=style&index=0&id=25a06c27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a06c27",
  null
  
)

export default component.exports